// Day detail popover — shown when a day is tapped in the calendar or
// attention list. Full periods breakdown + staff-off with reasons.
export function DayDetailPopover({ day, tierColors, onClose }) {
  if (!day) return null;
  const dayLabel = new Date(day.ymd + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
  function fmt(t) {
    if (!t || typeof t !== 'string') return '';
    const [h, m] = t.split(':').map((x) => parseInt(x, 10));
    const hr = h === 0 ? 12 : h > 12 ? h - 12 : h;
    const ap = h < 12 ? 'a' : 'p';
    return m === 0 ? `${hr}${ap}` : `${hr}:${String(m).padStart(2,'0')}${ap}`;
  }
  const reasonLabel = {
    approved_tor: 'TOR approved',
    pending_tor: 'TOR pending',
    availability_reduction: 'availability',
    other_location: 'other café',
  };
  return (
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} className="card"
        style={{ width: '100%', maxWidth: 560, maxHeight: '80vh', overflow: 'auto', padding: 18 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>{dayLabel}</div>
          <button onClick={onClose} className="btn-secondary" style={{ fontSize: 11, padding: '3px 10px' }}>Close</button>
        </div>
        {day.closed ? (
          <div style={{ color: '#757575' }}>Closed.</div>
        ) : (day.periods || []).length === 0 ? (
          <div style={{ color: '#757575' }}>No staffing periods configured for this day.</div>
        ) : (
          (day.periods || []).map((p, i) => {
            const req = Number(p.required_staff) || 0;
            const avail = Number(p.min_available) || 0;
            const ratio = req > 0 ? avail / req : 1;
            const periodTier = avail >= req ? 'green' : ratio >= 0.75 ? 'yellow' : ratio >= 0.5 ? 'orange' : 'red';
            const c = tierColors[periodTier];
            return (
              <div key={i} style={{ padding: 10, borderLeft: `3px solid ${c.stripe}`, marginBottom: 8, background: c.bg, borderRadius: 4 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <div style={{ fontWeight: 700, color: c.stripe }}>{p.name}</div>
                  <div style={{ fontSize: 11, color: '#37474f' }}>{fmt(p.start_time)}–{fmt(p.end_time)}</div>
                </div>
                <div style={{ fontSize: 13, marginTop: 2 }}>
                  <b>{avail}</b> available · needs <b>{req}</b>
                  {p.avg_available != null && p.avg_available !== avail && ` · avg ${p.avg_available}`}
                </div>
                {(p.staff_off || []).length > 0 && (
                  <div style={{ marginTop: 6, paddingTop: 4, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                    <div style={{ fontSize: 10, color: '#757575', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>
                      Off this window ({p.staff_off.length})
                    </div>
                    {p.staff_off.map((s, si) => (
                      <div key={si} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '1px 0', fontSize: 12 }}>
                        <span>{s.name}</span>
                        <span style={{ color: '#5a6470' }}>
                          {(s.reasons || []).map((r) => reasonLabel[r] || r).join(' · ')}
                          {s.detail ? ` — ${s.detail}` : ''}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
